import '@angular/compiler';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import { hmrBootstrap } from './hmr';


if (environment.production) {
  enableProdMode();
}

const redirectHosts = [
  'main.dsinvcp.ext.dev.aws-uset1-dmz.mosedge.mercer.com',
  'main.dsinvcp.ext.stg.aws-uset1-dmz.mosedge.mercer.com',
  'main.dsinvcp.ext.prd.aws-uset1-dmz.mosedge.mercer.com',
  'investorportal.mercer.com',
  'admin.dsinvcp.noweb.dev.aws-uset1-dmz.mosedge.mercer.com',
  'admin.dsinvcp.noweb.stg.aws-uset1-dmz.mosedge.mercer.com',
  'admin.dsinvcp.noweb.prd.aws-uset1-dmz.mosedge.mercer.com',
  'localdev-dsportal.mercer.com'
];

const redirectPaths = [
  '/msso/forgot-password',
  '/provision/terms-and-conditions',
  '/terms-of-use',
  '/disclaimers/au',
  '/disclaimers/nz'
];

const currentPath = window.location.pathname.replace(/\/+$/, '');
const shouldRedirect =
  redirectHosts.includes(window.location.hostname) &&
  redirectPaths.includes(currentPath);
if (shouldRedirect) {
  window.location.replace(window.location.origin);
}

if (!shouldRedirect && environment.pendoEnabled) {
  (function (apiKey) {
    (function (p, e, n, d, o) {
      /* eslint-disable */
      let v, w, x, y, z;
      o = p[d] = p[d] || {};
      o._q = [];
      v = ['initialize', 'identify', 'updateOptions', 'pageLoad'];
      for (w = 0, x = v.length; w < x; ++w) {
        (function (m) {
          o[m] = o[m] || function () {
            o._q[m === v[0] ? 'unshift' : 'push']([m].concat([].slice.call(arguments, 0)));
          };
        })(v[w]);
      }
      y = e.createElement(n);
      y.async = !0;
      y.src = 'https://cdn.pendo.io/agent/static/' + apiKey + '/pendo.js';
      z = e.getElementsByTagName(n)[0];
      z.parentNode.insertBefore(y, z);
    })(window, document, 'script', 'pendo');
  })(environment.pendoKey); // The Pendo API must stay here with the rest of the Pendo snippet
}
const bootstrap = () => platformBrowserDynamic().bootstrapModule(AppModule, {
  preserveWhitespaces: true
});

if (!shouldRedirect) {
  if (environment.hmr) {
    if (module['hot']) {
      hmrBootstrap(module, bootstrap);
    } else {
      console.error('HMR is not enabled for webpack-dev-server');
      console.log('Are you using the --hmr flag for ng serve?');
    }
  } else {
    bootstrap();
  }
}


// Toggle shadow class on atlas-table when scrolled horizontally (mobile sticky column)
document.addEventListener('scroll', (e) => {
  const target = e.target as HTMLElement;
  if (target && target.tagName === 'ATLAS-TABLE') {
    if (target.scrollLeft > 0) {
      target.classList.add('dsp-table-scrolled');
    } else {
      target.classList.remove('dsp-table-scrolled');
    }
  }
}, true);